import { Percent } from "@silo/types";
import { match } from "ts-pattern";
import { asPercent, DebtRewardsState } from "@silo/utils";

export function getDebtRewardsStateColor(
  debtRewardsState: DebtRewardsState
): string {
  return match(debtRewardsState)
    .with("netCost", () => "text-amber-300")
    .with("netYield", () => "text-green-400")
    .with("none", () => "")
    .exhaustive();
}

interface FormatDepositAprParams {
  displayCollateralYields: boolean;
  totalCollateralApr: Percent;
  totalProtectedApr: Percent;
}

export function formatDepositApr(params: FormatDepositAprParams): string {
  const { displayCollateralYields, totalCollateralApr, totalProtectedApr } =
    params;

  if (displayCollateralYields) {
    return asPercent(totalCollateralApr);
  }

  return asPercent(totalProtectedApr);
}
